import classNames from 'classnames'
import type {ReactNode} from 'react'

import IconButton from '../../../../common/IconButton/IconButton'
import {useHint} from '../../../../packages/Hints/Hints.hooks'
import type {Hint} from '../../../../packages/Hints/Hints.types'
import {HINT_CATEGORY, toHintId} from '../../../../packages/Hints/Hints.types'

import styles from './SidebarHeader.css'

type Props = {
  className?: string
  search: ReactNode
  sidebarCollapsed: boolean
  toggleCollapseSidebar: () => void
}

const toggleSidebarHint: Hint = {
  id: toHintId('toggle-sidebar'),
  name: 'Toggle Sidebar',
  text: 'Press the S key to show or hide the sidebar anytime.',
  category: HINT_CATEGORY.sidebar,
  obligatory: true,
}

function SidebarHeader({className, search, sidebarCollapsed, toggleCollapseSidebar}: Props) {
  useHint(toggleSidebarHint)

  const title = `${sidebarCollapsed ? 'Show' : 'Hide'} sidebar`

  return (
    <div
      className={classNames(className, styles.header, {
        [styles.collapsed]: sidebarCollapsed,
      })}
      role="presentation"
      title={sidebarCollapsed ? title : undefined}
      onClick={sidebarCollapsed ? toggleCollapseSidebar : undefined}
    >
      <div className={styles.searchWrapper}>
        <div className={styles.search}>{search}</div>
        <div className={styles.collapseIconButtonWrapper}>
          <IconButton
            iconClassName={styles.collapseIcon}
            icon={sidebarCollapsed ? 'double-chevron-right' : 'double-chevron-left'}
            title={title}
            onClick={!sidebarCollapsed ? toggleCollapseSidebar : undefined}
          />
        </div>
      </div>
      {sidebarCollapsed && (
        <div className={styles.collapseTextWrapper}>
          <span data-hint-container-id={toggleSidebarHint.id} className={styles.collapseText}>
            {`S – ${sidebarCollapsed ? 'show' : 'hide'} sidebar`}
          </span>
        </div>
      )}
    </div>
  )
}

export default SidebarHeader
